<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import config from "../../../config/config";
import { debounce } from "../../../state/helpers";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  data() {
    return {
      config: config,
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 1,
      search: "",
      moment,
      id: "",
      booking: {
        is_cancel: [],
      },
      typeform: {
        selectedVehicleModel: [],
        selectedChargerType: [],
      },
      modelList: [],
      chargerTypeList: [],
      makeData: {
        id: "",
        name: "",
      },
      searchData: debounce(() => {
        this.getBatterySizes();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "id",
          sortable: true,
          label: "#",
        },
        {
          key: "vehicle_model_name",
          sortable: true,
          label: "Model Name",
        },
        {
          key: "type",
          sortable: true,
          label: "Charger Type",
        },
        {
          key: "name",
          sortable: true,
          label: "Size",
        },
        {
          key: "action",
          sortable: false,
          label: "Action",
        },
      ],
    };
  },
  props: ["userId"],
  components: {},
  validations: {
    makeData: {
      name: { required },
    },
    typeform: {
      selectedVehicleModel: { required },
      selectedChargerType: { required },
    },
  },
  computed: {
    ...mapGetters("vehicle", [
      "getAllBatterySize",
      "loading",
      "batterySizeCount",
      "pagination",
      "getAllModel",
      "getAllTypes",
      "getShowBatterySize",
      "getUpdateStatus",
    ]),
  },
  mounted() {
    this.getBatterySizes();
    this.getModels();
    this.getTypes();
  },
  methods: {
    ...mapActions("vehicle", [
      "getBatterySize",
      "showBatterySize",
      "updateBatterySize",
      "createBatterySize",
      "deleteBatterySize",
      "getModelList",
      "getTypeList",
    ]),
    getBatterySizes(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getBatterySize(filters);
    },
    addBatterySize() {
      this.typeform.selectedVehicleModel = [];
      this.typeform.selectedChargerType = [];
      this.makeData.name = "";
      this.$bvModal.show("bv-modal-add-vehicle-make");
    },
    async getModels() {
      await this.getModelList();
      this.getAllModelList();
    },
    getAllModelList() {
      this.modelList = this.getAllModel.map((item) => ({
        id: item.id,
        name: item.name,
      }));
    },
    async getTypes() {
      await this.getTypeList();
      this.getAllTypeList();
    },
    getAllTypeList() {
      this.chargerTypeList = this.getAllTypes.map((item) => ({
        id: item.id,
        type: item.type,
      }));
    },
    editChargerType(size_id) {
      this.resetForm();
      var data = {
        id: size_id,
      };
      this.showBatterySize(data).then(() => {
        this.makeData.id = this.getShowBatterySize.id;
        this.makeData.name = this.getShowBatterySize.name;
        this.typeform.selectedVehicleModel = this.getShowBatterySize.vehicle_model;
        this.typeform.selectedChargerType = this.getShowBatterySize.charger_type;
        this.$bvModal.show("bv-modal-edit-vehicle-make");
      });
    },
    submitEditForm() {
      this.$v.$touch();
      if (this.$v.makeData.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("id", this.makeData.id);
        fd.append("name", this.makeData.name);
        fd.append("vehicle_model_id", this.typeform.selectedVehicleModel.id);
        fd.append("charger_type_id", this.typeform.selectedChargerType.id);
        this.updateBatterySize(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getBatterySizes();
          }
          this.$bvModal.hide("bv-modal-edit-vehicle-make");
        });
      }
    },
    submitAddForm() {
      this.$v.$touch();
      if (this.$v.makeData.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("name", this.makeData.name);
        fd.append("vehicle_model_id", this.typeform.selectedVehicleModel.id);
        fd.append("charger_type_id", this.typeform.selectedChargerType.id);
        this.createBatterySize(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getBatterySizes();
          }
          this.$bvModal.hide("bv-modal-add-vehicle-make");
        });
      }
    },
    deleteBatterySizes(make_id) {
      if (confirm("Are You Sure to Delete #" + make_id + " Battery Size")) {
        const fd = new FormData();
        fd.append("id", make_id);
        this.deleteBatterySize(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getBatterySizes();
          }
        });
      }
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getBatterySizes();
    },
    resetForm() {
      this.$v.$reset();
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-2">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">
                    Battery Size ({{ batterySizeCount }})
                  </h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select
                          class="custom-select"
                          v-model="perPages"
                          @change="searchData()"
                        >
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <b-button
                    class="page-title-right btn btn-success btn-rounded mr-2 add-btn"
                    @click="
                      addBatterySize();
                      $bvModal.show('bv-modal-add-vehicle-make');
                    "
                    ><i class="mdi mdi-plus mr-1"></i>
                    Add Battery Size
                  </b-button>
                  <a
                    :href="config.appurl + 'download-battery-size-data'"
                    class="btn btn-primary btn-md btn-rounded ml-1"
                  >
                    Download All Data
                  </a>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :items="getAllBatterySize"
                  :fields="fields"
                  :busy="loading"
                  class="table-class"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(action)="items">
                    <b-button
                      @click="editChargerType(items.item.id)"
                      class="btn btn-success btn-rounded"
                    >
                      <i class="bx bxs-edit"></i>
                    </b-button>
                    &nbsp;
                    <b-button
                      @click="deleteBatterySizes(items.item.id)"
                      class="btn btn-danger btn-rounded"
                    >
                      <i class="bx bx-trash"></i>
                    </b-button>
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllBatterySize.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Battery Size Data Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getBatterySizes"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- Add vehicle make Model start -->
    <b-modal id="bv-modal-add-vehicle-make" hide-footer @hidden="resetForm">
      <template #modal-title>Add Battery Size</template>
      <form action="#" @submit.prevent="submitAddForm">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Vehicle Model</label>
              <multiselect
                v-model="typeform.selectedVehicleModel"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="name"
                track-by="name"
                placeholder="Search Vehicle Model"
                open-direction="bottom"
                :options="modelList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                :class="{ 'is-invalid': $v.typeform.selectedVehicleModel.$error }"
              >
              </multiselect>
              <div
                v-if="$v.typeform.selectedVehicleModel.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.typeform.selectedVehicleModel.required"
                  >Please select vehicle model</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Charger Type</label>
              <multiselect
                v-model="typeform.selectedChargerType"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="type"
                track-by="type"
                placeholder="Search Charger Type"
                open-direction="bottom"
                :options="chargerTypeList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                :class="{ 'is-invalid': $v.typeform.selectedChargerType.$error }"
              >
              </multiselect>
              <div v-if="$v.typeform.selectedChargerType.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.selectedChargerType.required"
                  >Please select charger type</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Size</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Size"
                v-model="$v.makeData.name.$model"
                :class="{ 'is-invalid': $v.makeData.name.$error }"
                name="name"
              />
              <div v-if="$v.makeData.name.$error" class="invalid-feedback">
                <span v-if="!$v.makeData.name.required">Please enter size</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-add-vehicle-make');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Add vehicle make Model end -->
    <!-- Edit vehicle make Model start -->
    <b-modal id="bv-modal-edit-vehicle-make" hide-footer @hidden="resetForm">
      <template #modal-title>Edit Battery Size</template>
      <form action="#" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Vehicle Model</label>
              <multiselect
                v-model="typeform.selectedVehicleModel"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="name"
                track-by="name"
                placeholder="Search Vehicle Model"
                open-direction="bottom"
                :options="modelList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                :class="{ 'is-invalid': $v.typeform.selectedVehicleModel.$error }"
              >
              </multiselect>
              <div
                v-if="$v.typeform.selectedVehicleModel.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.typeform.selectedVehicleModel.required"
                  >Please select vehicle model</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Charger Type</label>
              <multiselect
                v-model="typeform.selectedChargerType"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="type"
                track-by="type"
                placeholder="Search Charger Type"
                open-direction="bottom"
                :options="chargerTypeList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                :class="{ 'is-invalid': $v.typeform.selectedChargerType.$error }"
              >
              </multiselect>
              <div v-if="$v.typeform.selectedChargerType.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.selectedChargerType.required"
                  >Please select charger type</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Size</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Size"
                v-model="$v.makeData.name.$model"
                :class="{ 'is-invalid': $v.makeData.name.$error }"
                name="name"
              />
              <div v-if="$v.makeData.name.$error" class="invalid-feedback">
                <span v-if="!$v.makeData.name.required">Please enter size</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-edit-vehicle-make');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Edit vehicle make Model end -->
  </div>
</template>
<style>
.multiselect {
  width: 250px !important;
}
</style>
